<template>
    <u-select-underlined v-model="modelValue" v-bind="$attrs" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-select-underlined>
</template>

<script>
import USelectUnderlined from "@/components/publish/styles/forms/u-select-underlined.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        USelectUnderlined,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
